export default {
    title: `In progress ...`,
    text: `We are in the process of aggregating your data, meanwhile, you can complete your profile`,
    button: `Complete your profile`,
};
